import * as React from "react";
const SvgSave = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	width: "1em",
	height: "1em",
	...props
}, /* @__PURE__ */ React.createElement("defs", null), /* @__PURE__ */ React.createElement("g", {
	id: "save_svg__Layer_2",
	"data-name": "Layer 2"
}, /* @__PURE__ */ React.createElement("g", {
	id: "save_svg__Layer_1-2",
	"data-name": "Layer 1"
}, /* @__PURE__ */ React.createElement("path", {
	d: "M0 0h24v24H0z",
	style: { fill: "none" }
}), /* @__PURE__ */ React.createElement("path", {
	d: "M20.13 23H3.91a1 1 0 0 1-1-.81 1.5 1.5 0 0 1 0-.22V10.92c0-7.21 0-7.21 1-7.22h13a1 1 0 0 1 .71.3l3.24 3.24a1 1 0 0 1 .29.71V22a1 1 0 0 1-1.02 1M4.91 21h14.22V8.36L16.47 5.7H4.88v14.67Z",
	style: { fill: "currentColor" }
}), /* @__PURE__ */ React.createElement("path", {
	d: "M15.81 22.5H8.24a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .5-.5h7.57a.51.51 0 0 1 .5.5v7a.5.5 0 0 1-.5.5m-7.07-1h6.57v-6H8.74ZM15.81 7.91H8.24a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h7.57a.5.5 0 0 1 .5.5v5.41a.51.51 0 0 1-.5.5m-7.07-1h6.57V2.5H8.74Z",
	style: { fill: "currentColor" }
}), /* @__PURE__ */ React.createElement("path", {
	d: "M13.65 17.63H10.4a.5.5 0 0 1-.5-.5.5.5 0 0 1 .5-.5h3.25a.51.51 0 0 1 .5.5.5.5 0 0 1-.5.5M13.65 19.8H10.4a.5.5 0 0 1-.5-.5.5.5 0 0 1 .5-.5h3.25a.5.5 0 0 1 .5.5.51.51 0 0 1-.5.5",
	style: { fill: "currentColor" }
}))));
export default SvgSave;
